import { Icon } from "@iconify/react";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import { formatDate } from "../lib/utils";

export default function DrawingConfirmationPage() {
  const [action, setAction] = useState("");
  const [reason, setReason] = useState("");

  const renderRow = (label, value) => (
    <div className="row spread align_start">
      <span className="label gray">{label}</span>
      <span className="value text_right">{value}</span>
    </div>
  );
  return (
    <div className="mail-page">
      <header className="mail-page-header">
        <div className="logo_wrapper">
          <img src="/assets/images/Structualtants.svg" alt="Logo" className="logo small" />
          <div className="logo_text text_center">
            <span className="title ">Structualtants</span>
            <span className="subtile">Designs LLP</span>
            <span className="tagline">We make it simple.</span>
          </div>
        </div>
        <div>Design C1.1 Design_R0 Review</div>
      </header>
      <main>
        <div className="row">
          <div className="row start spread">
            <span>C1.1 Design_R0</span>
            <button className="ghost_btn btn">
              <Icon icon="tabler:download" className="icon" />
              Download
            </button>
          </div>
          <div className="row end">
            <button className="cta_outline_btn btn" onClick={() => setAction("revision")}>
              <Icon icon="bx:revision" className="icon" />
              Request revision
            </button>
            <button className="cta_btn btn" onClick={() => setAction("approve")}>
              <Icon icon="duo-icons:approved" className="icon" />
              Approve Design
            </button>
          </div>
        </div>
        {(action === "revision" || action === "revision_confirmed") && (
          <div className="row">
            <label htmlFor="reason" className="label">
              Reason for request revision
            </label>
            <input
              type="text"
              name="reason"
              id="reason"
              className="input full"
              onChange={(e) => setReason(e.target.value)}
            />
            <button
              type="button"
              className="btn cta_outline_btn"
              onClick={() => setAction("revision_confirmed")}
              disabled={!reason}
            >
              Submit
            </button>
          </div>
        )}
        <div className="column ">
          <div className="font-md">Project Details</div>
          <div className="grid-1-2 small">
            <div className="card rounded column ">
              <span>Basic Details</span>
              {renderRow("Project Name", "Project 1")}
              {renderRow("Project Date", formatDate(new Date()))}
              {renderRow("Site Address", "804 F, Random street, random lane, Wakad, Pune, Maharashtra 400060")}
              {renderRow("Locality", "Wakad, Pune")}
            </div>
            <div className="card rounded column">
              <span>Type of Work</span>
              <div className="grid-2-cols-with-divider">
                <div className="column">
                  {renderRow("Work type", "Building Work")}
                  {renderRow("Building Work", "Bungalow")}
                  {renderRow("Basement", "1")}
                  {renderRow("Parking", "2")}
                  {renderRow("Ground Floor", "Mezzanine")}
                </div>
                <div className="column">
                  {renderRow("No. of upper floors", "2")}
                  {renderRow("Provision for additional floors", "Yes")}
                  <div></div>
                  <div className="column shrink full">
                    <span>No. of Structural drawings:</span>
                    <div className="row spread full">
                      {renderRow("Column footing drawing", "2")}
                      {renderRow("No. of Slabs", "8")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ApproveModal open={action === "approve"}></ApproveModal>
      <RevisionModal open={action === "revision_confirmed"}></RevisionModal>
    </div>
  );
}

const ModalWrapper = styled(Modal)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const ApproveModal = ({ open }) => {
  return (
    <ModalWrapper open={open}>
      <div className="modal_container column align_center">
        <Icon icon="duo-icons:approved" className="primary_icon" />
        <span className="font-md">Design C1.1_R0 Approved.</span>
      </div>
    </ModalWrapper>
  );
};

const RevisionModal = ({ open }) => {
  return (
    <ModalWrapper open={open}>
      <div className="column modal_container align_center">
        <Icon icon="bx:revision" className="primary_icon" />
        <span className="font-md">Design C1.1_R0 Revision request sent.</span>
      </div>
    </ModalWrapper>
  );
};
